import styled from 'styled-components';

export const Container = styled.main`
  width: 100%;
`;



// WEBPACK FOOTER //
// ./src/appStyles.js